<template>
    <b-card no-body>
        <b-modal ref="nicor-billing-modal">
            <template #modal-header>
                <h3>{{$t('ATTENTION_NICOR_CUSTOMERS')}}</h3>
            </template>
            <div>
                <span>{{englishPreEffectiveDateNicorMessage}}</span>
                <br/>
                <br/>
                <span>{{spanishPreEffectiveDateNicorMessage}}</span>
            </div>

                    <template #modal-footer="{ ok, cancel, hide }">
                        <b-button size="sm" variant="success" @click="ok()">
                            OK
                        </b-button>
                    </template>
        </b-modal>
        <b-card-header>
            <h4>{{$t('MAKE_PAYMENT')}}</h4>
            <ul v-show="showHeader">
                <li class="mt-1">{{customerBalance}}</li>
                <li v-show="avoidDisconnectAmount !== 0">{{avoidDisconnectMessage}}</li>
                <li v-show="balanceInfo.balanceGrace !== 0">{{reinstateMessage}}</li>
                <li v-show="paymentPlanBalance !== 0">{{paymentPlanBalanceMessage}}</li>
            </ul>
        </b-card-header>
        <b-card-body>
            <b-card-sub-title class="mt-1">{{$t('ONE_TIME_PAYMENT')}}<div v-show="showCCFeeAgreement"> {{$t('APPLY_CCFEE')}}</div></b-card-sub-title>


            <b-form class="mt-3" @submit.stop.prevent>
                <b-form-group>
                    <b-form-radio v-model="radio" name="some-radios" v-if="balanceInfo.balanceGrace != 0" :value="balanceInfo.balanceGrace">{{ $t('REINSTATE_AMOUNT') }} ${{balanceInfo.balanceGrace}}</b-form-radio>
                    <b-form-radio v-model="radio" name="some-radios" v-if="balanceInfo.pastDueBalance != 0" :value="balanceInfo.pastDueBalance">{{$t('PAST_DUE')}} ${{balanceInfo.pastDueBalance}}</b-form-radio>
                    <b-form-radio v-model="radio" name="some-radios" v-if="balanceInfo.currentBalance  != 0" :value="balanceInfo.currentBalance">{{$t('TOTAL_ACCOUNT_BALANCE')}} ${{balanceInfo.currentBalance}}</b-form-radio>
                    <b-form-radio v-model="radio" name="some-radios" v-if="paymentPlanBalance != 0 && custBalanceInfo.customerBalanceCurrentDue  != 0" :value="custBalanceInfo.customerBalanceCurrentDue">{{$t('CURRENT_BALANCE_DUE')}} ${{custBalanceInfo.customerBalanceCurrentDue}}</b-form-radio>
                    <b-form-radio v-model="radio" name="some-radios" v-if="avoidDisconnectAmount != 0" :value="avoidDisconnectAmount">{{$t('AVOID_DISCONNECT')}} ${{avoidDisconnectAmount}}</b-form-radio>
                    <b-form-radio v-model="radio" name="some-radios" value="otherAmount">{{$t('OTHER_AMOUNT')}}</b-form-radio>
                </b-form-group>
                <b-form-group v-if="radio == 'otherAmount'">
                    <b-input v-model="otherAmount" :state="preValidateAmount" id="amount-to-pay"></b-input>
                    <b-form-invalid-feedback :state="preValidateAmount">{{$t('VALID_AMOUNT')}}</b-form-invalid-feedback>
                </b-form-group>
                <b-form-checkbox class="mt-3"
                                 id="ccFee"
                                 v-model="agreeCCFee"
                                 name="ccFee"
                                 v-show="showCCFeeAgreement">
                    <div v-if="usingNewVerbage == false">{{$t('AGREE_ELECTRONICFEE')}}</div>
                    <div v-else>{{$t('AGREE_BILLEDELECTRONICFEE')}}</div>

                </b-form-checkbox>

            </b-form>
            <b-button @click="validate" class="mt-3" :disabled="disablePayButton">{{$t('PAY_NOW')}}</b-button>
            <b-button @click="returnHome" class="mt-3" style="float: right">{{$t('RETURN_HOME')}}</b-button>
            <b-form-invalid-feedback :state="warnCredit">{{$t('CREDIT_WARNING')}}</b-form-invalid-feedback>

        </b-card-body>
        <b-card-footer>
            <span v-html="$t('AUTOPAY')"></span>
        </b-card-footer>
    </b-card>
</template>

<script>
import Repo from '../repo';
    import { mapGetters } from 'vuex';
    import i18n from '../localization';

    export default {

        name: "QuickPayConfirm",

        data:() =>({

            radio: '',
            otherAmount: 0,
            agreeCCFee: false,
            ccFee: 2.50,
            showCCFeeAgreement: true,
            balanceInfo: {},
            custBalanceInfo: null,
            avoidDisconnectInfo: [],
            showHeader: false,
            usingNewVerbage: false,
            jarvisSettings: {
                quickPayNewVerbiage:{
                    settingName: "treasury-billed-charge-adjust-codes",
                    settingType: "bool",
                    value: false
                },
                preEffectiveDateNicorMessage:{
                    settingName: "Finance.QuickPay.NicorBillingPreEffectiveDateMessage",
                    settingType: "string",
                    value: ""
                }
            }
        }),
        computed: {
            quickPayNewVerbiage() { return this.jarvisSettings.quickPayNewVerbiage.value },
            englishPreEffectiveDateNicorMessage() {
                return this.jarvisSettings.preEffectiveDateNicorMessage.value.split('|')[0]
            },
            spanishPreEffectiveDateNicorMessage() {
                return this.jarvisSettings.preEffectiveDateNicorMessage.value.split('|')[1]
            },
            ...mapGetters({
                customer: 'lobby/quickPayCustomer',
                paymentConfiguration: 'lobby/paymentConfiguration'
                    }),
            warnCredit() {
                if (this.balanceInfo.currentBalance) {
                    return !(this.otherAmount > this.balanceInfo.currentBalance);
                } else {
                    return true;
                }
            },
            disablePayButton() {
                if (this.radio == "") {
                    return true;
                }
                if (!this.agreeCCFee) {
                    return true;
                }
                if (this.radio !== "otherAmount" && this.radio < 1) {
                    return true;
                }
                if (this.radio == "otherAmount" && this.otherAmount < 1) {
                    return true;
                }
                if (this.balanceInfo.currentBalance > 0 && this.customer.statusCode == "D" && this.customer.billingType != "1")
                {
                    var errorMessage = i18n.t('DEENERGIZED');
                    this.$store.dispatch('shell/addErrorHTML', errorMessage);
                    return true;
                }
                if (this.radio == "otherAmount" && this.otherAmount >= 1) {
                    return false;
                }
                if (this.balanceInfo.currentBalance > 0 && this.customer.statusCode !="D") {
                    return false;
                }
                if (this.balanceInfo.currentBalance > 0 && this.customer.statusCode == "D" && this.customer.billingType == "1") {
                    return false;
                }
           
                return true;
            },
            customerRequest() {
                return { CustomerNumber: this.customer.customerNumber, ANumber: this.customer.aNumber };
            },
            avoidDisconnectMessage() {
                let message = i18n.t('AVOID_DISCONNECT_MESSAGE');
                if (this.avoidDisconnectAmount > 0) {
                    return message.replace("{0}",this.avoidDisconnectAmount);
                } else {
                    return 0;
                }
            },
            avoidDisconnectAmount() {
                if (this.avoidDisconnectInfo.length == 1) {
                    return this.avoidDisconnectInfo[0].amountToAvoidDisconnect;
                }
                else if (this.avoidDisconnectInfo.length > 0) {
                    return avoidDisconnectInfo.reduce((info1, info2) => info1.amountToAvoidDisconnect + info2.amountToAvoidDisconnect);
                } else {
                    return 0;
                }
            },
            paymentPlanBalance() {
                if (this.custBalanceInfo != null && this.custBalanceInfo.balanceSummaryModel.paymentPlanBalance > 0) {
                    return this.custBalanceInfo.balanceSummaryModel.paymentPlanBalance;
                } else {
                    return 0;
                }
            },
            reinstateMessage() {
                let message = i18n.t('REINSTATE_AMOUNT_MESSAGE');
                if (this.balanceInfo.balanceGrace > 0 && this.balanceInfo.hasTreatment) {
                    return message.replace("{0}",this.balanceInfo.balanceGrace);
                }else {
                    return 0;
                }
            },
            paymentPlanBalanceMessage() {
                if (this.custBalanceInfo != null && this.custBalanceInfo.balanceSummaryModel.paymentPlanBalance > 0 && this.custBalanceInfo.balanceSummaryModel.paymentPlanBalanceDue == 0) {
                    let message = i18n.t('PAYMENTPLAN_BALANCE_AMOUNT_MESSAGE');
                    return message.replace("{0}", this.custBalanceInfo.balanceSummaryModel.paymentPlanBalance);
                } 
                else if (this.custBalanceInfo != null && this.custBalanceInfo.balanceSummaryModel.paymentPlanBalance > 0 && this.custBalanceInfo.balanceSummaryModel.paymentPlanBalanceDue > 0) {
                    let message = i18n.t('PAYMENTPLAN_BALANCE_AMOUNT_DUE_MESSAGE');
                    return message.replace("{0}", this.custBalanceInfo.balanceSummaryModel.paymentPlanBalance).replace("{1}", this.custBalanceInfo.balanceSummaryModel.paymentPlanBalanceDue);
                } 
                else {
                    return 0;
                }
            },
            customerBalance() {
                if (this.balanceInfo.pastDueBalance > 0) {
                    return i18n.t('CURRENT_BALANCE_PAST_DUE_MESSAGE').replace("{0}", this.balanceInfo.currentBalance).replace("{1}", this.balanceInfo.pastDueBalance);
                } else {
                    return i18n.t('CURRENT_BALANCE_MESSAGE').replace("{0}", this.balanceInfo.currentBalance);
                }
            },
            preValidateAmount() {
                return this.otherAmount >= 1;
            }
        },
        created() {
            Repo.QuickPayService.GetAllBalancesByCustomerNumber(this.customerRequest).then(res => this.balanceInfo = res);
            Repo.QuickPayService.GetCustomerBalance({ CustomerNbr: this.customer.customerNumber}).then(res => this.custBalanceInfo = res);
            Repo.QuickPayService.GetAmountToAvoidDisconnect(this.customerRequest).then(res => this.avoidDisconnectInfo = res.avoidDisconnectInformation);
            Repo.QuickPayService.IsCCFeeCharged(this.customerRequest).then(res => {
                if (!res.isCharged) {
                    this.ccFee = 0.00;
                    this.agreeCCFee = true;
                    this.showCCFeeAgreement = false;
                }
                this.showHeader = true;
            })
            this.getQuickPaySettings();
            this.showNicorBillingMessage();
        },
        methods: {
            showNicorBillingMessage() {
                Repo.QuickPayService.IsNicorCustomer({ ANumber: this.customer.aNumber }).then(res => {
                    if (res?.isNicorCustomer) {
                        this.$refs["nicor-billing-modal"].show()
                    }
                })
                return
            },
            today() {return new Date() },

            validate: async function () {
                var callBackUrl = (window.location.href.includes("localhost") || window.location.href.includes("int")) ? "https://www.int.ambitenergy.io" : "https://www.ambitenergy.com";
                var additionalParameters = Object.assign(
                    {},
                    {
                    CreditCardProcessingFee: this.ccFee
                    }
                );
                var body = Object.assign(
                    {},
                    {
                    Amount: this.radio == "otherAmount" ? this.otherAmount : this.radio,
                    AccountHolderName: this.paymentConfiguration.accountName,
                    ExternalKeyValue: this.customer.aNumber,
                    ExternalKeyType: "CUSTOMER",
                    PaymentCampaignCode: "QUICKPAY",
                    CallBackUrl: callBackUrl,
                    AdditionalParameters: additionalParameters,
                    DisplayLanguageOptions: ["en", "sp"],
                    CountryCode: "US"
                    }
                );
                this.$store.dispatch("lobby/getPaymentToken", body);
            },
            getQuickPaySettings: async function () {
                for (const setting in this.jarvisSettings) {
                    let settingObj = this.jarvisSettings[setting]
                    let settingRequest = { settingName: settingObj.settingName, settingType: settingObj.settingType }

                    await Repo.QuickPayService.GetAppSetting(settingRequest).then(res => {
                        switch (settingObj.settingName) {
                            case this.jarvisSettings.quickPayNewVerbiage.settingName:
                                this.jarvisSettings.quickPayNewVerbiage.value = res?.settingValue
                                break;
                            case this.jarvisSettings.preEffectiveDateNicorMessage.settingName:
                                this.jarvisSettings.preEffectiveDateNicorMessage.value = res?.stringSettingValue
                                break;
                        }
                    })
                }
            },
            returnHome() {
                Repo.Redirect.ReturnToAmbit();
            }
        }
};
</script>
